import {QuestionComponent} from './QuestionComponent'
import {OpenComponent} from 'app/modules/survey/survey-viewer/survey-question/types/open/open.component'
import {Matrix} from 'app/models/questions/Matrix'
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms'

export class Open extends Matrix {
    getDisplayComponent() {
        return new QuestionComponent(OpenComponent, this)
    }

    buildStatementFormGroup(): UntypedFormGroup {
        const form = new UntypedFormGroup({})

        this.statementKeys.forEach(sKey => {
            form.addControl(
                sKey,
                new UntypedFormControl(
                    true,
                    {
                        // updateOn: 'blur', // <---- Évite la sauvegarde vers firebase de manière intensive...
                    }
                ),
            )
        })
        return form
    }
}
